import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';
// let agentId="12345605947539573"
function* IncentiveDataResponse({ payload: { offset, limit, search, fromDate, toDate , agentId } }) {
  try {
    const response = yield call(axiosPrivate.get, `${process.env.REACT_APP_API_BASE_URL}api/dashboard/incentives?agentId=${agentId ? agentId : '' }&page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search} ` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}`);
    if (response.status === 200) {
      yield put(actions.getIncentiveDataSuccess(response.data?.incentives,response.data.total));
    } else {
      yield put(actions.getIncentiveDataFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getIncentiveDataFailed(error?.message));
  }
}

function* deleteIncentiveResponse({ payload: { id , agentId } }) {

  try {
    const response = yield call(axiosPrivate.delete, `api/dashboard/incentives/agentId=${agentId ? agentId : '' }/${id}`);
    if (response.status === 200) {
      yield put(actions.deleteIncentiveSuccess("Incentive Deletd Sucessfully"));
      // Dispatch GET_USER_DATA action to fetch updated data
      yield put(actions.getIncentiveData(0, 10));

    } else {
      yield put(actions.deleteIncentiveFailed(response.message));

    }
  } catch (error) {
    // yield put(actions.deleteIncentiveFailed(error));
    yield put(actions.deleteIncentiveFailed("Incentive does not Deletd due to some reason"));
  }
}

function* getServiceResponse() {
  try {
    const response = yield call(axiosPrivate.get, `/cou-dashboard/billers/categories/all`);
      if (response.status === 200) {
      yield put(actions.getServicesSuccess(response.data));
    } else {
      yield put(actions.getServicesFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getServicesFailed(error?.response?.data?.message));
  }
}
function* getVoucherResponse({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate.get, `api/dashboard/incentives/vouchers?agentId=${agentId ? agentId : '' }`);
    yield put(actions.getVouchersDataSuccess(response?.data?.vouchers));   
  } catch (error) {
    yield put(actions.getVouchersDataFailed(error?.response?.data?.message));
  }
}

function* addIncentiveResponse({ payload: { data } }) {
  try {
    const response = yield call(axiosPrivate.post, `api/dashboard/incentives/create`, data);
    if (response.status === 201) {
      yield put(actions.addIncentiveSuccess("Incentive added succcessfully"));
      // Dispatch GET_USER_DATA action to fetch updated data
      yield put(actions.getIncentiveData());
    } else {
      yield put(actions.addIncentiveFailed(response.message));
    }
  } catch (error) {
    yield put(actions.addIncentiveFailed(error?.response?.data?.message));
  }
}
function* editServiceResponse({ payload: { incentive_id, data } }) {
  try {
    const response = yield call(axiosPrivate.put, `api/dashboard/incentives/${incentive_id}`, data);
    if (response.status === 200) {
      yield put(actions.editIncentiveSuccess("Incentive Update succcessfully"));
      // Dispatch GET_Service_DATA action to fetch updated data
      yield put(actions.getIncentiveData());
    } else {
      yield put(actions.editIncentiveFailed(response.message));
    }
  } catch (error) {
    yield put(actions.editIncentiveFailed(error?.response?.data?.message));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_INCENTIVE_DATA, IncentiveDataResponse)]);
  yield all([takeEvery(actions.DELETE_INCENTIVE, deleteIncentiveResponse)]);
  yield all([takeEvery(actions.GET_SERVICES, getServiceResponse)]);
  yield all([takeEvery(actions.ADD_INCENTIVE, addIncentiveResponse)]);
  yield all([takeEvery(actions.EDIT_INCENTIVE, editServiceResponse)]);
  yield all([takeEvery(actions.GET_VOUCHERS_DATA, getVoucherResponse)]);
}
